/* Copyright (c) 2017 Backpack Health LLC */

import React from 'react';
import PropTypes from 'prop-types';

import DatePickerToggle from './DatePickerToggle';
import { TimeFromNow, HealthEntryDuration } from '../localization/LocalizedDate';
import DateUtil from '../../utilities/DateUtil';
import { Icons } from '../../bphComponents/bundle';
import COLORS from '../styles/Colors';
import FlexRow from './FlexRow';

function getValidation(startDateData, endDateData) {
  const maxEndDate = DateUtil.getMaxEndDate({ date: endDateData.date, precision: endDateData.precision });
  const isValid = endDateData.endDate && startDateData.date && DateUtil.isBefore(maxEndDate, startDateData.date);

  return {
    isValid,
    message: isValid ? '' : 'error.date-validator.end-before-start.message',
  };
}

class FuzzyDateRange extends React.Component {

  constructor(props) {
    super(props);

    this.handleStartDateChange = this.handleStartDateChange.bind(this);
    this.handleEndDateChange = this.handleEndDateChange.bind(this);

    this.state = {
      isInvalid: false,
    };
  }

  handleEndDateChange(endDateData) {
    const validation = getValidation({ date: this.startDate, precision: this.startDatePrecision }, endDateData);
    this.props.onChangeEndDate(endDateData, validation);
  }

  handleStartDateChange(startDateData) {
    const validation = getValidation(startDateData, { date: this.props.endDate, precision: this.props.endDatePrecision });
    this.props.onChangeStartDate(startDateData, validation);
  }

  render() {
    const hasValidStartAndEnd = this.props.startDate && this.props.endDate && DateUtil.isBefore(this.props.startDate, this.props.endDate);

    return (
      <div style={{ height: this.props.height }}>
        <FlexRow style={{ justifyContent: 'flex-start' }}>


          <DatePickerToggle
            label="pastDates.startDate.field.label"
            date={this.props.startDate}
            precision={this.props.startDatePrecision}
            name="start_date"
            onChange={this.handleStartDateChange}
            preventFloating={true}
            isFuzzy
            hasToday
            allowNull
            initialFocus={this.props.hasInitialFocus}
            onFocus={this.props.onFocusStartDate}
            onCancel={this.props.onCancelStartDate}
            earliestDateLimit={this.props.earliestDateLimit}
            latestDateLimit={this.props.latestDateLimit}
            warningHint={this.props.warningHint}
            earliestDateWarningLimit={this.props.earliestDateWarningLimit}
            regularHint={(
              <TimeFromNow
                dateData={{
                  date: this.props.startDate,
                  precision: this.props.startDatePrecision,
                }}
              />
            )}
          />
          <div style={{ marginLeft: 6, marginRight: 6 }}>
            <Icons.IconArrowRight.Small color={COLORS.gsMedDark} />
          </div>
          <DatePickerToggle
            label="pastDates.endDate.field.label"
            date={this.props.endDate}
            precision={this.props.endDatePrecision}
            name="end_date"
            onChange={this.handleEndDateChange}
            preventFloating={true}
            isFuzzy
            hasToday
            allowNull
            onFocus={this.props.onFocusEndDate}
            onCancel={this.props.onCancelEndDate}
            earliestDateLimit={this.props.earliestDateLimit}
            latestDateLimit={this.props.latestDateLimit}
            warningHint={this.props.warningHint}
            earliestDateWarningLimit={this.props.earliestDateWarningLimit}
            regularHint={(
              <TimeFromNow
                dateData={{
                  date: this.props.endDate,
                  precision: this.props.endDatePrecision,
                }}
              />
            )}
          />
        </FlexRow>
        <div className="font-caption-1 font-color-gsMedDark" style={{ paddingTop: '8px' }}>
          {
            hasValidStartAndEnd ? (
              <HealthEntryDuration
                startDateData={{ date: this.props.startDate, precision: this.props.startDatePrecision }}
                endDateData={{ date: this.props.endDate, precision: this.props.endDatePrecision }}
                isCurrent={false}
              />
            ) : null
          }
        </div>
      </div>
    );
  }
}
FuzzyDateRange.propTypes = {
  height: PropTypes.string,
  startDate: PropTypes.string.isRequired,
  endDate: PropTypes.string,
  startDatePrecision: PropTypes.string,
  endDatePrecision: PropTypes.string,
  hasInitialFocus: PropTypes.bool,

  onChangeStartDate: PropTypes.func.isRequired,
  onFocusStartDate: PropTypes.func.isRequired,
  onCancelStartDate: PropTypes.func.isRequired,
  onChangeEndDate: PropTypes.func.isRequired,
  onFocusEndDate: PropTypes.func.isRequired,
  onCancelEndDate: PropTypes.func.isRequired,
  toggleIsPeriod: PropTypes.func.isRequired,
  earliestDateLimit: PropTypes.string,
  latestDateLimit: PropTypes.string,
  warningHint: PropTypes.string,
  earliestDateWarningLimit: PropTypes.string,
};

export default FuzzyDateRange;
